import React, {PureComponent} from 'react'
import * as cookies from '@rambler-id/cookies'
import {reachGoal, trackEvent} from 'utils/metrics'

export default function injectExperiment(key, test) {
  const uniq = `r_id_${key}`
  const tested = '1'

  return (Component) =>
    class InjectExperiment extends PureComponent {
      componentDidMount() {
        if (cookies.getItem(uniq) !== tested) {
          this.timeout = setTimeout(async () => {
            try {
              const result = await test()
              const params = {
                [key]: result
              }

              reachGoal(key, params)
              trackEvent(key, {[result]: true})
            } catch (error) {} // eslint-disable-line no-empty

            cookies.setItem(uniq, tested, {
              path: '/account',
              expires: 31,
              domain: 'id.rambler.ru',
              samesite: 'none',
              secure: true
            })
          }, 1000)
        }
      }

      componentWillUnmount() {
        clearTimeout(this.timeout)
      }

      render() {
        return <Component {...this.props} />
      }
    }
}
